import { Component, Input } from '@angular/core';

@Component({
  selector: 'sow-activation',
  template: `
    <div class="alert alert-warning sow-service-result">
      <p class="text-center">
        <i class="fa fa-exclamation-triangle"></i>&nbsp; <span translate>APP.TICKET.MESSAGE.SOW_SERVICE_APPLIED</span><br>
        ACSL Ticket <a [href]="'/ga2/#/unacc?url=%2Funacc%2FMaintDetView_Edit.jsp%3Frow0_Demndid%3D' + ticketId + '%26ejbEvent%3Dedit%26showTab%3DGenInfo'" target="_blank">{{ticketId}}</a>
      </p>
    </div>
  `
})
export class SowActivationComponent {
  @Input() public ticketId: number;
}